/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PopUp from '../../Popup';

import config from '../../../config';
import styles from '../../Notifications/errorNotification.module.scss';

class ErrorPopUp extends React.Component {
    render() {
        const {
            custom,
            message,
            cta,
            showNoCta,
            description,
        } = this.props;

        return (
            <PopUp
                className="popup-sm"
                onCloseClick={this.props.closePopup}
                config={{
                    fullScreen: false,
                    scrollable: false,
                    style: { maxHeight: '300px' },
                }}
            >
                <div className={`${styles.component}`}>
                    <div className={`title mb32 text-large`} dangerouslySetInnerHTML={{ __html: message }} />
                    {custom
                        ? (
                            <React.Fragment>
                                {description ? (
                                    <div className={`mb16`} dangerouslySetInnerHTML={{ __html: description }} />
                                ) : ''}
                            </React.Fragment>
                        )
                        : (
                            <div className={`mb16`}>
                                There was an issue processing the request. Please try again or contact our <a target="_blank" rel="noopener noreferrer" href={config.links.support}>Support Team</a> for assistance.
                            </div>
                        )
                    }
                    {!showNoCta && (
                        <button
                            onClick={this.props.closePopup}
                            type="button"
                            className="btn btn-primary btn-xl text-uppercase btn-block"
                        >
                            {custom && !!cta ? cta : 'Got it'}
                        </button>
                    )}
                </div>
            </PopUp>
        );
    }
}

export default ErrorPopUp;
